module.exports = __webpack_public_path__ + "img/graphic-12.ed6879fb.webp";